export const ROLES = {
  ADMIN: 'ADMIN',
  TEACHER: 'TEACHER',
  STUDENT: 'STUDENT',
  CHILD: 'CHILD',
  PARENT: 'PARENT',
  SCHOOL_ADMIN: 'SCHOOL_ADMIN',
  UNDEFINED: 'UNDEFINED'
}
